/*!
 * 开启多线程 优化大数据加载 v 0.1
 *
 */

// const BASE_DATASETS = "";
class DynamicWorker {
  constructor(worker) {
    /**
     * 数据处理函数
     */
    const formatFn = `const formatFn = ${worker.toString()};`;

    /**
     * 子线程
     */
    const onMessageFn = `self.onmessage = ({ data: { data, flag } }) => {
      const {method} = data;
      if (data.data && method === 'format') {
        formatFn(data.data).then((data) => {
          self.postMessage({
            data: data,
            flag
          });
        })
      }
    }`;

    // 转为js文件
    const blob = new Blob([`(()=>{${formatFn}${onMessageFn}})()`], {
      type: "text/javascript",
    });

    // 创建Worker
    this.worker = new Worker(URL.createObjectURL(blob));

    /**
     * 返回结果
     * @param {*} param
     */
    const handleResult = ({ data: { data, flag } }) => {
      console.log("返回结果", data);
      const resolve = this.flagMapping[flag];
      if (resolve) {
        // 返回结果
        resolve(data);
        delete this.flagMapping[flag];
      }
    };

    // 创建监听
    this.worker.addEventListener("message", handleResult);

    //
    this.flagMapping = {};
    // URL.revokeObjectURL() 静态方法用来释放一个之前通过调用 URL.createObjectURL() 创建的已经存在的 URL 对象。
    URL.revokeObjectURL(blob);
  }

  /**
   * 动态调用
   */
  send(data) {
    const w = this.worker;
    //  给 Worker 传递消息 flag是为了避免短时间重复调用
    const flag = new Date().toString();

    return new Promise((res) => {
      // 异步操作
      console.log("异步操作", data);
      this.flagMapping[flag] = res;
      w.postMessage({
        data,
        flag,
      });
    });
  }

  close() {
    this.worker.terminate();
  }
}

export default DynamicWorker;
